
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/services/ot-cybersecurity",
      function () {
        return require("private-next-pages/[locale]/services/ot-cybersecurity.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/services/ot-cybersecurity"])
      });
    }
  